<script>
  // @ts-check
  // @ts-ignore
  // eslint-disable-next-line no-unused-vars
  import * as Types from "./newsLetterTypes";

  // @ts-ignore
  import Image from "../../atoms/Image.svelte";

  import NewsletterForm from "./NewsletterForm.svelte";
  // @ts-ignore
  import DynamicHeadingContext from "../../atoms/DynamicHeadingContext.svelte";
  // @ts-ignore
  import DynamicHeading from "../../atoms/DynamicHeading.svelte";
  import Markdown from "../../atoms/Markdown.svelte";

  /** Primarily used for testing
   * @type {string} */
  export let id = undefined;

  /** The type of layout under the featured layout
   * @type { "vertical" | "horizontal" }
   */
  export let layoutVariant = "horizontal";

  /**
   * optional prop for handling form submission natively
   *
   * @type {Types.FormProps}
   * */
  export let formProps;

  /**
   * The formFields props.
   * @type {Types.FormFieldsProps}
   */
  export let formFields = undefined;

  /**
   * The featured image in the card
   * @type {import('../../types/shared.js').Image} Image
   */
  export let featuredImage = undefined;

  /** The title of the NewsLetter Confirmation
   * @type {string} */
  export let title = undefined;

  /**
   * The description of the NewsLetter Confirmation
   * @type {string}
   */
  export let description = null;

  /**
   * Indicates whether the form is currently being submitted
   * @type {boolean}
   */
  export let isSubmitting = false;

  export let onSubmit = () => undefined;

  /**
   * The error message to display when the form submission fails
   * @type {string}
   */
  export let formSubmitErrorMessage = undefined;

  /**
   * The class of this of the content
   * @type {string}
   */
  export let contentClass = null;

  export let containerClass = null;

  export let descriptionClass = null;

  const hasFeatureImage = !!featuredImage?.src && !!featuredImage?.alt;

  $: watchIsSubmitting = isSubmitting;
</script>

<DynamicHeadingContext>
  <div {id}>
    {#if layoutVariant === "horizontal"}
      <div class="relative flex flex-col lg:flex-row {containerClass} min-h-full">
        {#if hasFeatureImage}
          <div class="flex-1">
            <Image {...featuredImage} aspectRatioClasses="aspect-3/4" />
          </div>
        {:else}
          <div class="flex-1 {contentClass}">
            <DynamicHeading class="heading-md">
              {title}
            </DynamicHeading>
            <Markdown input={description} class={descriptionClass} {id} />
          </div>
        {/if}

        <div class="flex flex-1 flex-col {contentClass}">
          {#if hasFeatureImage}
            <div class="grow">
              <DynamicHeading class="heading-md">
                {title}
              </DynamicHeading>
              <Markdown input={description} class={descriptionClass} {id} />
            </div>
          {/if}
          <div class="pt-12.5 md:pt-15 lg:pt-0">
            <NewsletterForm
              {id}
              on:formSubmit={onSubmit}
              {formProps}
              {formFields}
              {formSubmitErrorMessage}
              isSubmitting={watchIsSubmitting}
            />
          </div>
        </div>
      </div>
    {:else}
      <NewsletterForm
        {id}
        on:formSubmit={onSubmit}
        {formProps}
        {formFields}
        {formSubmitErrorMessage}
        isSubmitting={watchIsSubmitting}
      />
    {/if}
  </div>
</DynamicHeadingContext>
